import React from 'react';

/**
 * Voice interaction button — speaker icon for TTS, mic icon for STT.
 */
export default function VoiceButton({ mode = 'speak', active = false, onClick, size = 40 }) {
  const isMic = mode === 'listen';

  return (
    <button
      onClick={onClick}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: 'none',
        background: active
          ? (isMic ? '#d63031' : '#6c5ce7')
          : '#30363d',
        color: '#fff',
        fontSize: size * 0.45,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        transition: 'all 0.15s',
        boxShadow: active ? `0 0 12px ${isMic ? '#d63031' : '#6c5ce7'}40` : 'none',
      }}
      title={isMic ? 'Voice input' : 'Read aloud'}
    >
      {isMic ? '\uD83C\uDF99' : '\uD83D\uDD0A'}
    </button>
  );
}
